import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 w-full p-2" }
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = { class: "flex flex-row justify-between items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-gray-800" }, "Para", -1)
const _hoisted_5 = { class: "flex flex-row items-center gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Enviar a todos", -1)
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-gray-800" }, "Asunto", -1)
const _hoisted_9 = { class: "flex flex-col gap-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-gray-800" }, "Mensaje", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-4" }, null, -1)
const _hoisted_12 = { class: "flex flex-row gap-4 justify-between w-full" }
const _hoisted_13 = { class: "flex flex-col w-32" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "upload-input",
  class: "rounded-full bg-green-700 text-senter text-sm px-4 py-2 text-white border-0 shadow-lg"
}, " Subir Archivos ", -1)
const _hoisted_15 = { class: "flex flex-col gap-2 overflow-auto max-h-64 items-center" }
const _hoisted_16 = { class: "relative flex flex-row items-center bg-gray-100 rounded-full w-80 text-xs px-4 py-2 justify-between gap-4 text-gray-600" }
const _hoisted_17 = { class: "flex flex-row items-center w-64 text-wrap" }
const _hoisted_18 = { class: "truncate" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, " Formatos permitidos: jpg, jpeg, png, gif, svg, bmp, pdf. ", -1)
const _hoisted_20 = { class: "flex flex-row items-center gap-4" }
const _hoisted_21 = ["disabled"]

import { watch, computed, ref } from "vue";

import { NotificationServices } from "@/services/notifications/NotificationServices";

import NewModal from "../atoms/NewModal.vue";
import Switch from "../atoms/Switch.vue";
import MessageUserSelector from "../molecules/MessageUserSelector.vue";
import Swal from "sweetalert2";


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  id: {
    type: Number,
    default: 0,
  },
},
  emits: ["update:visible"],
  setup(__props, { emit }) {

const props = __props;





const notificationService = new NotificationServices();

const message = ref({
  users: [],
  subject: "",
  description: "",
  files: [],
  all: false,
});

const resp = ref();

const messageIsPending = ref<boolean>(false);

const handleSendMessage = async () => {
  messageIsPending.value = true;
  resp.value = await notificationService.sendMessage(message.value);
};

const handleFiles = async (event: Event) => {
  if (event.target) {
    message.value.files = event.target.files;
  }
};

const handleUsers = async (selectedUsers: any) => {
  message.value.users = selectedUsers;
};

const removeFile = async (fileIndex) => {
  const dt = new DataTransfer();

  for (let i = 0; i < message.value.files.length; i++) {
    const file = message.value.files[i];
    if (fileIndex !== i) {
      dt.items.add(file); // here you exclude the file. thus removing it.
    }
  }
  message.value.files = dt.files;
};

const disableSubmit = computed(
  () =>
    (message.value.users.length > 0 || message.value.all) &&
    message.value.subject != "" &&
    message.value.description != "" &&
    messageIsPending.value != true
);

watch(props, () => {
  message.value.users = [];
  message.value.subject = "";
  message.value.description = "";
  message.value.files = [];
  message.value.all = false;
});

watch(resp, () => {
  if (resp.value.success) {
    emit("update:visible");
    Swal.fire("Listo!", "Mensaje enviado exitosamente!.", "success");
  } else {
    Swal.fire("Error", "Oops, hubo un error", "error");
  }

  messageIsPending.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NewModal, {
      title: "Mensaje Nuevo",
      visible: __props.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = (e) => _ctx.$emit('update:visible', e))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = () => _ctx.$emit('update:visible')),
            type: "button",
            class: "flex flex-row items-center rounded-full px-4 py-2 bg-gray-400 transition text-sm shadow text-white"
          }, " Cancelar "),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (handleSendMessage())),
            disabled: !disableSubmit.value,
            class: "btn disabled:bg-gray-500 transition-all"
          }, " Enviar ", 8, _hoisted_21)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(Switch, {
                  actived: message.value.all,
                  "onUpdate:actived": _cache[0] || (_cache[0] = 
                  () => {
                    message.value.all = !message.value.all;
                  }
                )
                }, null, 8, ["actived"])
              ])
            ]),
            _createVNode(MessageUserSelector, {
              disabled: message.value.all,
              onSetUsers: handleUsers
            }, null, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((message.value.subject) = $event)),
              type: "text",
              class: "border border-gray-300 rounded-md p-2"
            }, null, 512), [
              [_vModelText, message.value.subject]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message.value.description) = $event)),
              class: "border border-gray-300 rounded-md p-2"
            }, "\n          ", 512), [
              [_vModelText, message.value.description]
            ])
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("input", {
                id: "upload-input",
                hidden: "",
                accept: ".jpeg,.jpeg,.png,.gif,.svg,.bmp,.pdf",
                onChange: _cache[3] || (_cache[3] = (event) => handleFiles(event)),
                type: "file",
                multiple: ""
              }, null, 32)
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.value.files, (file, fileIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-row flex-wrap gap-2 items-center",
                  key: fileIndex
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", _hoisted_18, _toDisplayString(file.name), 1)
                    ]),
                    _createVNode(_component_mdicon, {
                      name: "delete",
                      onClick: () => removeFile(fileIndex)
                    }, null, 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _hoisted_19
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})